import { removeToken, removeUserId, removeUserInfo } from "@/common/cookies";
// import { Message } from 'element-ui'
import { ElMessage } from "element-plus";
import { UserService } from "@/services";
import { getGoogleAvatarFromJWT } from "@/common/utils";
export default {
  async login({ commit }, params) {
    const result = await UserService.login(params);
    if (result.status === 200) {
      commit("SET_TOKEN", result.data.token);
      commit("SET_USER_INFO", result.data.userinfo);
      commit("SET_USER_ID", result.data.userinfo?.user_info_id);
    }
    return result;
  },
  async logout({ commit }, params, callback) {
    const result = await UserService.logout({ user_id: params.userId });
    if (result.status === 200) {
      commit("SET_TOKEN", "");
      commit("SET_USER_INFO", {});
      commit("SET_USER_ID", "");
      commit("SET_AVATAR_URL", ""); // 清除头像URL
      removeToken();
      removeUserInfo();
      removeUserId();
      callback && callback();
    } else {
      ElMessage.error(result.message);
    }
    return result;
    // this.$auth.strategy.token.reset()
    // this.$auth.$storage.removeCookie('userInfo')
    // this.$auth.$storage.removeCookie('userId')
    // this.$auth.$storage.removeCookie('token')
  },
  async getUserInfo({ commit }, params) {
    commit("SET_USER_INFO_LOADING", true);
    const result = await UserService.getInfo(params);
    if (result.status === 200) {
      console.log("request getUserInfo", result.data);
      const userInfo = {
        ...result.data.userinfo,
        user_like: result.data.user_like,
        user_info_id: result.data.userId,
        userId: result.data.userId,
      };
      commit("SET_USER_INFO", userInfo);

      // 如果后端返回了头像URL，保存到state
      if (userInfo?.avatar_url) {
        commit("SET_AVATAR_URL", userInfo.avatar_url);
      }
    } else {
      console.log(result.message);
    }
    commit("SET_USER_INFO_LOADING", false);
    return result;
  },
  // -------------- 第三方登录-------------
  async loginWithGoogle({ commit }, params) {
    const result = await UserService.loginWithGoogle(params);
    if (result.status === 200) {
      commit("SET_TOKEN", result.data.token);
      commit("SET_USER_INFO", result.data.userinfo);
      commit("SET_USER_ID", result.data.userinfo?.user_info_id);

      // 从Google JWT token中提取头像URL并保存到state
      if (params.token) {
        const avatarUrl = getGoogleAvatarFromJWT(params.token);
        if (avatarUrl) {
          commit("SET_AVATAR_URL", avatarUrl);
          console.log("Google头像URL已保存到state:", avatarUrl);
        }
      }
    }
    return result;
  },
  async loginWithApple({ commit }, params) {
    const result = await UserService.loginWithApple(params);
    if (result.status === 200) {
      commit("SET_TOKEN", result.data.token);
      commit("SET_USER_INFO", result.data.userinfo);
      commit("SET_USER_ID", result.data.userinfo?.user_info_id);

      // Apple不提供头像URL，清除state中的头像
      // 如果后端返回了头像URL，可以从result.data.userinfo中获取
      if (result.data.userinfo?.avatar_url) {
        commit("SET_AVATAR_URL", result.data.userinfo.avatar_url);
      } else {
        commit("SET_AVATAR_URL", "");
      }
    }
    return result;
  },

  // ---------------- 设置用户积分 ----------------
  async setUserCreditsSum({ commit }, credits) {
    commit("SET_USER_CREDITS_SUM", credits);
  },
  // ---------------- 设置是否是开发环境 ----------------
  async setIsDev({ commit }, isDev) {
    commit("SET_IS_DEV", isDev);
  },
};
